module.exports = __webpack_public_path__ + "media/1alB-a-ya.b232ea12.mp3";